import {BranchServiceModuleConfiguration} from "./BranchesServiceModuleConfiguration";
import {BranchAddressServiceName, BranchesServiceName} from "../utils/names/serviceNames";
import {BranchesService} from "./service/branches-service";
import {BranchesAddressService} from "./service/branches-address.service";

BranchServiceModuleConfiguration.createNewModule()
    .service(BranchAddressServiceName, BranchesAddressService.instance)
    .service(BranchesServiceName, BranchesService.instance);
